import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-mobile-app-download-links',
  templateUrl: './mobile-app-download-links.component.html',
  styleUrls: ['./mobile-app-download-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileAppDownloadLinksComponent {
  /**
   * Ссылка для скачивания из App Store
   */
  @Input() appStoreLink?: string;

  /**
   * Ссылка для скачивания из Google Play
   */
  @Input() googlePlayLink?: string;

  /**
   * Ссылка для скачивания из RuStore
   */
  @Input() ruStoreLink?: string;
}
